const handleSettingsWizardState = (
  state: string,
  setModalState: (state: string) => void
) => {
  setModalState(state);
};

export default handleSettingsWizardState;
